export enum LNEContentBlocksUid {
  FREE_ENTRY = 'free_entry',
  IMAGE = 'lne_image_display_block',
  ONE_TO_FOUR_COLUMNS = 'one_to_four_columns',
  QUOTE = 'lne_quote_column_block',
  RICH_TEXT = 'lne_rich_text_column',
  VIDEO = 'lne_video_display_block',
}
